function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "current",
  strokeWidth: 10,
  strokeMiterlimit: 10,
  d: "M90.744,94.965C101.336,85.533,108,71.799,108,56.5 C108,28.057,84.943,5,56.5,5C28.058,5,5,28.057,5,56.5c0,15.299,6.665,29.033,17.257,38.465c8.422,7.865,12.849,10.04,12.849,28.037 v14.743H56.5c0.001,0,21.396,0,21.396,0v-14.743C77.896,105.005,82.322,102.83,90.744,94.965z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "current",
  strokeWidth: 10,
  strokeMiterlimit: 10,
  d: "M56.359,149.206h21.832c0,0-0.171,19.168-8,25.531 H56.359H42.527c-7.829-6.362-8-25.531-8-25.531H56.359z"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "current",
  strokeWidth: 10,
  strokeMiterlimit: 10,
  x1: 36.47,
  y1: 163.538,
  x2: 76.249,
  y2: 163.538
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "current",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  d: "M28.729,56.847 c0.817-14.983,12.699-27.022,27.615-28.088"
});

var SvgLight = function SvgLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "113px",
    height: "180px",
    viewBox: "0 0 113 180",
    enableBackground: "new 0 0 113 180",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/light.111b5743.svg";
export { ForwardRef as ReactComponent };